module.exports = __webpack_public_path__ + "fonts/AiDeep-2.8e59798d.otf";